import styled from "styled-components";

export const SocialItems = styled.div`
  display: flex;
  gap: 20px;
`;
